module.exports = __webpack_public_path__ + "static/media/case_details_03.5c06ceaa.jpg";